import PropTypes from 'prop-types';
import warrantyScanStatusColor from '../../../transforms/warrantyScanStatusColor';
import warrantySourceColor from '../../../transforms/warrantySourceColor';
import warrantyStateColor from '../../../transforms/warrantyStateColor';
import Badge from '../../Badge/Badge';

function ShowStatus({
  state = null,
  active = null,
  scanAvailable = null,
  size = 'large',
}) {
  const stateNames = {
    unsent: 'not sent',
    overdue1: 'overdue 1 day',
    overdue2: 'overdue 3 days',
    overdue3: 'overdue 5+ days',
  };

  function getName() {
    if (state) {
      return stateNames[state] || state.replace(/_/g, ' ');
    }
    return active === false ? 'Inactive' : 'Active';
  }

  function getStateColor() {
    // PFG states, sources, and scan statuses come from the shared warranty maps
    // so the show badges and the PFG table columns can never drift apart. The
    // admin / partner / user cases below were only ever reached by the PFG show
    // page passing warranty.source in as the state, so they now resolve here.
    const pfgColor =
      warrantyStateColor(state) ||
      warrantySourceColor(state) ||
      warrantyScanStatusColor(state);

    if (pfgColor) {
      return pfgColor;
    }

    switch (state) {
      case 'pending':
      case 'processing':
      case 'unsent':
      case 'on_hold':
      case 'returned':
      case 'inactive':
      case 'ready_to_produce':
      case 'unpaid':
      case 'partially_paid':
      case 'No':
      case 'imported':
      case 'new_annual':
      case 'one_off':
        return 'yellow';
      case 'sent':
      case 'complete':
      case 'refunded':
      case 'review_for_production':
      case 'customer_service_review':
      case 'orthodontic_office_review':
      case 'lab_review':
        return 'blue';
      case 'active':
      case 'completed':
      case 'being_manufactured':
      case 'preparing_shipment':
      case 'partially_shipped':
      case 'shipped':
      case 'delivered':
      case 'paid':
      case 'Yes':
      case 'Patient':
      case 'series_order':
      case 'renewal':
      case 'approved':
        return 'green';
      case 'overdue1':
      case 'overdue2':
      case 'overdue3':
      case 'cancelled':
      case 'needs_attention':
      case 'payment_failed':
      case '1.0 Import':
      case 'expedited':
      case 'free_trial':
      case 'rejected':
        return 'red';
      case 'Courtesy Order':
      case 'courtesy_order':
        return 'purple';
      default:
        return 'gray';
    }
  }

  function getColor() {
    if (state) {
      return getStateColor();
    }

    if (active === false) {
      return 'red';
    }

    return 'blue';
  }

  return scanAvailable || scanAvailable === null ? (
    <Badge name={getName()} color={getColor()} withDot={false} size={size} />
  ) : (
    <Badge
      className="m-0 p-0"
      name="Awaiting Scan From Provider"
      color="red"
      withDot={false}
      size={size}
    />
  );
}

ShowStatus.propTypes = {
  state: PropTypes.string,
  active: PropTypes.bool,
  scanAvailable: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'large']),
};

export default ShowStatus;
